module.exports = __webpack_public_path__ + "static/media/girl.312329d1.png";